import { Singleton, type SingletonInstance } from '@tunein/web-utils';
import type { createFavoritesStore } from './favoritesStore';
import type { createPlayerStore } from './playerStore';

export interface Stores {
  playerStore: ReturnType<typeof createPlayerStore>;
  favoritesStore: ReturnType<typeof createFavoritesStore>;
}

class StoresSingleton extends Singleton<Stores> {
  init(stores: Stores) {
    this.instance = stores;
  }
}

export const stores = new StoresSingleton() as SingletonInstance<
  Stores,
  StoresSingleton
>;
